/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Lazy_Duck_DashInputs */

const fr_neat_lazy_duck_dash = /** @type {(inputs: Neat_Lazy_Duck_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la fermeture du contact`)
};

/**

* @param {Neat_Lazy_Duck_DashInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const neat_lazy_duck_dash = /** @type {((inputs?: Neat_Lazy_Duck_DashInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Lazy_Duck_DashInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_neat_lazy_duck_dash(inputs)
});